import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { Chart, PieChart } from "devextreme-react";
import { Label, Legend, Series, ValueAxis, VisualRange } from "devextreme-react/chart";
import { AprEtsTabJ as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabJ = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const upwardBoundField = () => {
    const propertyName = pn<AprResponseModel>("upwardBound");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.upwardBound} {formatPercentTotal(props.data?.upwardBound, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const upwardBoundMathScienceField = () => {
    const propertyName = pn<AprResponseModel>("upwardBoundMathScience");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.upwardBoundMathScience}{" "}
        {formatPercentTotal(props.data?.upwardBoundMathScience, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const veteranUpwardBoundField = () => {
    const propertyName = pn<AprResponseModel>("veteranUpwardBound");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.veteranUpwardBound}{" "}
        {formatPercentTotal(props.data?.veteranUpwardBound, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const gearUpField = () => {
    const propertyName = pn<AprResponseModel>("gearUp");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.gearUp} {formatPercentTotal(props.data?.gearUp, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const otherField = () => {
    const propertyName = pn<AprResponseModel>("other");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.other} {formatPercentTotal(props.data?.other, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const servedByMoreThanOneField = () => {
    const propertyName = pn<AprResponseModel>("servedByMoreThanOne");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.servedByMoreThanOne}{" "}
        {formatPercentTotal(props.data?.servedByMoreThanOne, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">
          Talent Search Participants Also Served During Reporting Year by Another Federally Funded Program
        </Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {upwardBoundField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {upwardBoundMathScienceField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {veteranUpwardBoundField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {gearUpField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {otherField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {servedByMoreThanOneField()}
              </Grid>
              <GridBreak />

              {/* <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid> */}
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={11}>
            <Chart id="bar-tab-j" dataSource={props.data?.chartValues}>
              <Series argumentField="label" valueField="value" type="bar" ></Series>

              <ValueAxis>
                <VisualRange startValue={0} />
                <Label customizeText={(arg) => `${arg.valueText}`} />
              </ValueAxis>
              <Legend visible={false} />
            </Chart>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
